import React, { useState, useEffect } from "react";
import {
  Box,
  VStack,
  Grid,
  Flex,
  useToast,
  Table,
  Tbody,
  Tr,
  Td
} from "@chakra-ui/react";
// import RingLoader from "react-spinners/RingLoader";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { useDisclosure } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

import Sidebar from "../sections/Sidebar/Sidebar";
import MerchantService from "../../services/merchant.service";
import CreateCaseButton from "../merchant-list/create-case-button-renderer";
import CreateCaseForm from "../Cases/create-case-form";
import BreadCrumbs from '../common/BreadCrumbs'
import Loader from '../common/Loader'; 
import Header from  '../sections/Header';

import {
  thousandSeparator,
  FormatDate,
} from "../../utils/utilities";
import { dateComparator, comparator } from '../../utils/ag-grid';
import { getCountryNameWithCountryCode } from '../../config/static/country';
import { viewFor } from '../../utils/preferences';

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

function TransactionView() {
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedMerchant, setselectedMerchant] = useState({});
  const [merchantRowData, setMerchantRowData] = useState([]);
  const preferences = JSON.parse(localStorage.getItem("preferences"));
  // Use the per-country merchant view for the file's country, falling back to the default.
  const dataHeader = [...viewFor("merchantView", new URLSearchParams(location.search).get("country"))];
  const toast = useToast();
  //const [fileName, setFileName] = useState("");
  const [fileDate, setFileDate] = useState(null);
  const [fileCountry, setFileCountry] = useState('');
  const [isLoading, setisLoading] = useState(false);

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true
  };

  const openModal = (data) => {
    setselectedMerchant(data);
    onOpen();
  };

  const cellUpdate = (props) => {
    if (typeof props["value"] !== "undefined") {
      let value = props["value"]["value"];
      if (typeof props["value"]["datatype"] !== "undefined") {
        switch (props["value"]["datatype"]) {
          case "percentage":
            if(props["value"]["isExactValueRequired"]){
              value = `${(props["value"]["value"] * 100).toFixed(2)}%`;
            }else{
              value = `${Math.round(props["value"]["value"] * 100)}%`;
            }
            break;
          case "currency":
            value = `${props["value"]["symbol"]}${props["value"]["value"]}`;
            break;
          default:
            break;
        }
      }
      if (typeof value == "string" && !isNaN(parseFloat(value)))
        return thousandSeparator(value);
      return value;
    }
    return;
  };

  const dynamicCellStyle = (params) => {
    if (
      typeof params.data[params["colDef"].field] !== "undefined" &&
      params.data[params["colDef"].field].hasOwnProperty("bg")
    )
      return { backgroundColor: params.data[params["colDef"].field].bg };
  };

  const calwidth = (param) => {
    if (!param) return 50;
    return param.length * 7 + 50;
  };
  
  // const updateMerchantCase = (caseData) => {
  //   let tempMerchantData = merchantRowData;
  //   let index = tempMerchantData.findIndex(
  //     (x) => x["_id"] === caseData.merchantObjID
  //   );
  //   tempMerchantData[index].case.pop();
  //   tempMerchantData[index].case.push(caseData);
  //   setMerchantRowData([...tempMerchantData]);
  // };

  const initialFetch = async (date = "",country="") => {
    try {
      setisLoading(true);
      let result = await MerchantService.fetch(date,{...(country !== "null" && {country})});
      if (result.error) {
        toast({
          title: result.error,
          position: "top",
          status: "error",
          isClosable: true,
        });
        setisLoading(false);
        return;
      }
      setMerchantRowData(result.result);
      //setFileName(result.fileName);
      setFileDate(result.fileDate);
      setFileCountry(getCountryNameWithCountryCode(result.fileCountry));
      setisLoading(false);
    } catch (e) {
      setisLoading(false);
      throw Error(e);
    }
  };

  useEffect(() => {
    initialFetch(new URLSearchParams(location.search).get("date"),new URLSearchParams(location.search).get("country"));
    //Disabling the ES-lint dependency warning, This hook is to implement componentdidmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Flex>
        <Sidebar />
        <Box w="100%">
          <Loader isLoading={isLoading} />
          <Header>
            <Box>
              <Table size="sm" variant="unstyled">
                <Tbody>
                  {/* <Tr>
                    <Td>File Name </Td>
                    <Td>:{fileName}</Td>
                  </Tr> */}
                  <Tr>
                    <Td> <b>File Date</b></Td>
                    <Td><b>: { !isNaN(Date.parse(fileDate)) ? FormatDate(fileDate) : fileDate}</b></Td>
                  </Tr>
                  <Tr>
                    <Td> <b>Country</b></Td>
                    <Td><b>: { fileCountry}</b></Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
          </Header>    
          <Box  pl="2" pb="2" > <BreadCrumbs /> </Box>
          <Grid minH="87vh" pl={3} pr={2}>
            <VStack spacing={1}>
              <Box
                style={{ height: "100%", width: "100%" }}
                className="ag-theme-alpine"
              >
                {isOpen && (
                  <CreateCaseForm
                    isOpen={isOpen}
                    onOpen={onOpen}
                    onClose={onClose}
                    merchant={selectedMerchant}
                    // updateChange={updateMerchantCase}
                  />
                )}

                <Box style={{ width: "100%", height: "100%" }}>
                  <AgGridReact
                    frameworkComponents={{
                      createCase: CreateCaseButton,
                    }}
                    defaultColDef={defaultColDef}
                    rowData={merchantRowData}
                    pagination={true}
                    paginationPageSize={17}
                    rowSelection="multiple"
                  >
                    <AgGridColumn
                      field="Action (Case)"
                      width={110}
                      cellRenderer="createCase"
                      sortable={false}
                      filter={false}
                      cellRendererParams={{ onClick: openModal, label: "add" }}
                      lockPosition={true}
                      pinned={"left"}
                    />
                    {dataHeader.map((item) =>
                      item.type === "date" ? (
                        <AgGridColumn
                          key={item.label}
                          comparator={dateComparator}
                          headerName={item.label}
                          filter="agDateColumnFilter"
                          filterParams={{
                            buttons: ["reset"],
                            valueGetter: (params) => {
                              return params.data[item.label].value;
                            },
                          }}
                          width={calwidth(item.label)}
                          field={item.value}
                          cellRenderer={cellUpdate}
                          cellStyle={dynamicCellStyle}
                          lockPosition={true}
                          pinned={item.pin}
                        ></AgGridColumn>
                      ) : item.type === "number" ? (
                        <AgGridColumn
                          key={item.label}
                          headerName={item.label}
                          filter="agNumberColumnFilter"
                          filterParams={{
                            buttons: ["reset"],
                            valueGetter: (params) => {
                              return params.data[item.label].value;
                            },
                          }}
                          comparator={comparator}
                          width={calwidth(item.label)}
                          field={item.value}
                          cellRenderer={cellUpdate}
                          cellStyle={dynamicCellStyle}
                          lockPosition={true}
                          pinned={item.pin}
                        ></AgGridColumn>
                      ) : (
                        <AgGridColumn
                          key={item.label}
                          headerName={item.label}
                          filter="agTextColumnFilter"
                          filterParams={{
                            buttons: ["reset"],
                            valueGetter: (params) => {
                              return params.data[item.label].value;
                            },
                          }}
                          comparator={comparator}
                          width={calwidth(item.label)}
                          field={item.value}
                          cellRenderer={cellUpdate}
                          cellStyle={dynamicCellStyle}
                          lockPosition={true}
                          pinned={item.pin}
                        ></AgGridColumn>
                      )
                    )}
                  </AgGridReact>
                </Box>
              </Box>
            </VStack>
          </Grid>
        </Box>
      </Flex>
    </Box>
  );
}

export default TransactionView;
